export default "__VITE_ASSET__c957cc21__"